import WaitingQueue from './waiting-queue.vue';

export default WaitingQueue;
